import { render } from "./DeleteIcon.vue?vue&type=template&id=4a755266&scoped=true&ts=true&lang=pug"
import script from "./DeleteIcon.vue?vue&type=script&lang=ts"
export * from "./DeleteIcon.vue?vue&type=script&lang=ts"

import "./DeleteIcon.vue?vue&type=style&index=0&id=4a755266&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a755266"]])

export default __exports__